// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e743ffe0","703":"27c69ea1","833":"ea35f9dc"}[chunkId] + ".chunk.js";
};